import React, { useEffect } from "react";
import {
  BusinessDetails,
  Home,
  Listing,
  NotFoundPage,
  CategoryList,
  RegisterBusiness,
  Register,
  CategoryDetails,
} from "./pages";
import $ from "jquery";

import {
  Routes as Switch,
  Route,
  useNavigate,
  useLocation,
  Routes,
} from "react-router-dom";
import { history } from "./helpers";
import { Helmet } from "react-helmet-async";
import MailSent from "./pages/register/mailSent";
import EmailVerified from "./pages/register/emailVerified";
import Dashboard from "./pages/dashboard/home";
import { ToastContainer } from "react-toastify";
import CompanyDetails from "./pages/companyDetails";
import Login from "./pages/login";
import Logout from "./components/logout";
import ProtectedRoute from "./components/dasboard/protectedRoute";
import SendCode from "./pages/forgotPassword/sendCode";
import UpdatePassword from "./pages/forgotPassword/updatePassword";
import Contact from "./pages/contact";
import CompanyRoutes from "./components/new-dashboard/company/CompanyRoutes";
import AddProduct from "./pages/dashboard/company/Products/addProduct";
import Products from "./pages/dashboard/company/Products/list/index";
import MarketPlace from "./pages/marketPlace";
import Cart from "./components/cart";
// import { useDispatch } from "react-redux";
// import { removeExpiredCart } from "./store/cart.slice";
import ProductDetail from "./pages/dashboard/company/Products/detail/productDetailClient";
import PaymentVerification from "./pages/marketPlace/paymentVerification";
import StripePayment from "./pages/marketPlace/StripePayment";
import ProductsList from "./pages/marketPlace/productList";

const App = () => {
  history.location = useLocation();
  history.navigate = useNavigate();

  // const dispatch = useDispatch();

  useEffect(() => {
    $("body iframe").remove();

    return () => {};
  }, []);

  // useEffect(() => {
  //   const oneHourInMilliseconds = 60 * 60 * 1000;

  //   const intervalId = setInterval(() => {
  //     dispatch(removeExpiredCart());
  //   }, oneHourInMilliseconds);

  //   return () => clearInterval(intervalId);
  // }, [dispatch]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Switch>
        <Route index path="/" element={<Home />}></Route>
        <Route path="/category/:id" element={<CategoryList />}></Route>
        <Route path="/category" element={<Listing />}></Route>
        <Route path="/home" element={<Home />}></Route>
        <Route path="/listing" element={<Listing />}></Route>
        <Route
          path="/business-details/:id"
          element={<BusinessDetails />}
        ></Route>
        <Route path="/*" element={<NotFoundPage />}></Route>
        <Route path="/add-business" element={<RegisterBusiness />}></Route>
        <Route
          path="/category-details/:id"
          element={<CategoryDetails />}
        ></Route>
        <Route path="/company-details/:id" element={<CompanyDetails />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/verify-email" element={<MailSent />}></Route>
        <Route path="/verify-email-success" element={<EmailVerified />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/logout" element={<Logout />}></Route>
        <Route path="/forgot-password" element={<SendCode />}></Route>
        <Route path="/update-password" element={<UpdatePassword />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/verify-otp" element={<MailSent forgotPassword />}></Route>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <CompanyRoutes />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/product_managment/list"
          element={
            <ProtectedRoute>
              <Products />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/product_managment/add"
          element={
            <ProtectedRoute>
              <AddProduct />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/market-place"
          element={
            // <ProtectedRoute>
            <MarketPlace />
            // </ProtectedRoute>
          }
        ></Route>{" "}
        <Route path="/market-place/products" element={<ProductsList />}></Route>
        <Route path="/market-place/category/:idCategory" element={<ProductsList />}></Route>
        <Route
          path="/market-place/cart"
          element={
            // <ProtectedRoute>
            <Cart />
            // </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/market-place/product-details/:id"
          element={
            // <ProtectedRoute>
            <ProductDetail />
            // </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/payment-verification"
          element={
            <ProtectedRoute>
              <PaymentVerification />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/stripe-payment"
          element={
            <ProtectedRoute>
              <StripePayment />
            </ProtectedRoute>
          }
        ></Route>
        {/*<Route path="/profile" element={*/}
        {/*    <ProtectedRoute>*/}
        {/*        <Profile />*/}
        {/*    </ProtectedRoute>*/}
        {/*}></Route>*/}
      </Switch>
      <Helmet>
        {/* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> */}
        <title>African Business Network</title>
        <link
          rel="stylesheet"
          href="../../assets/css/bootstrap/icons/bootstrap-icons.css"
        />
        <link
          rel="stylesheet"
          href="../../assets/vendor/bootstrap-icons/font/bootstrap-icons.css"
        />
        <link
          rel="stylesheet"
          href="../../assets/css/hs/mega-menu/mega-menu.min.css"
        />
        <link rel="stylesheet" href="../../assets/css/_theme.css" />

        <script
          defer
          async
          src="../../assets/js/bootstrap/bootstrap.bundle.min.js"
        ></script>
        <script defer async src="../../assets/js/hs/go-to/goto.min.js"></script>
        <script defer async src="../../assets/js/prism/prism.js"></script>
        <script
          defer
          async
          src="../../assets/js/hs/show-animation/show-animation.min.js"
        ></script>
        <script
          defer
          async
          src="../../assets/js/hs/mega-menu/mega-menu.min.js"
        ></script>
        <script
          defer
          async
          src="../../assets/js/hs/header/header.min.js"
        ></script>
        <script defer async src="../../assets/js/fslightbox/index.js"></script>
        <script defer async src="../../assets/js/theme.min.js"></script>
      </Helmet>
    </>
  );
};

export default App;
